import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Label } from './Label';
import { CALENDLY_URL, assessmentSteps } from '../data/site';
export function Assessment() {
  return <section id="assessment" className="grain relative isolate w-full overflow-hidden border-t border-cream/12 bg-navy py-24 sm:py-28" data-id="element-12" data-mp="34iilqvgra9nx">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-13" data-mp="3di5lzdxr19fe">
        <div className="absolute -right-40 top-0 h-full w-[55%] rotate-[14deg] border-l border-copper/20" data-id="element-14" data-mp="3dg2jhufetnts" />
      </div>

      <div className="relative mx-auto max-w-[960px] px-5 sm:px-8" data-id="element-15" data-mp="3n7yug62lh8ff">
        <Reveal data-id="element-16" data-mp="3n76xorx9h4nk">
          <div className="flex items-center gap-3" data-id="element-17" data-mp="3n9t5mso2dm6b">
            <span className="h-px w-10 bg-copper" data-id="element-18" data-mp="3i9x5j4ihmew1" />
            <Label data-id="element-19" data-mp="38yva7shjo9">The assessment</Label>
          </div>
          <h2 className="mt-5 max-w-2xl font-serif text-4xl italic leading-[1.06] text-cream sm:text-5xl" data-id="element-20" data-mp="4260canub6x">
            30 minutes, and you know where you stand
          </h2>
        </Reveal>

        <ol className="mt-14 border-t border-cream/12" data-id="element-21" data-mp="8ut3svrr2w13">
          {assessmentSteps.map((step, i) => <Reveal as="li" key={step.number} delay={0.05 * i} className="border-b border-cream/12 py-8 sm:py-10" data-id="element-22" data-mp="cvuwsuv2qbum" data-mpi={i}>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-12 sm:gap-8" data-id="element-23" data-mp="muakenuw72zd">
                <div className="sm:col-span-4" data-id="element-24" data-mp="rsvo4x9cs4sk">
                  <span className="font-sans text-[11px] tracking-label text-copper" data-id="element-25" data-mp="rs3sxnjo492t">
                    {step.number}
                  </span>
                  <h3 className="mt-3 font-serif text-2xl italic leading-tight text-cream" data-id="element-26" data-mp="10k5p39mpf37a">
                    {step.label}
                  </h3>
                </div>
                <p className="font-sans text-sm font-light leading-relaxed text-cream/70 sm:col-span-8 sm:pt-1 sm:text-base" data-id="element-27" data-mp="15llax3wphdqq">
                  {step.body}
                </p>
              </div>
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} data-id="element-28" data-mp="pszpqodhgnzl">
          <a href={CALENDLY_URL} target="_blank" rel="noreferrer noopener" className="group mt-12 inline-flex items-center gap-3 bg-copper px-6 py-4 font-sans text-[11px] uppercase tracking-label text-navy transition-colors duration-200 ease-editorial hover:bg-copper-light" data-id="element-29" data-mp="puaqefbmtfmh">
            Book a 30-minute AI strategy assessment
            <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-editorial group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-30" data-mp="18iz8yumn78v3" />
          </a>
        </Reveal>
      </div>
    </section>;
}